import {PeriodicDepositStatus} from '@/model/src/values/dv-100';
import {Redeemability} from '@/model/src/values/dv-31';
import {Guarantees} from '@/model/src/values/dv-88';
import {Plans} from '@/model/src/values/dv-9';
import {ContractTypes} from '@/model/src/values/dv-93';
import {UnitraxPeriodicDepositFrequency} from '@/model/src/values/dv-99';
export const ACCOUNT_TYPE_TO_DV_MAPPING = {
  CASH: Plans.NRSP,
  NRSP: Plans.NRSP,
  RSP: Plans.RSP,
  RRSP: Plans.RSP,
  RIF: Plans.RIF,
  RRIF: Plans.RIF,
  LIRA: Plans.LIRA,
  LIF: Plans.LIF,
  TFSA: Plans.TFSA,
  RLIF: Plans.RLIF,
  RLSP: Plans.RLSP,
  FHSA: Plans.FHSA,
} as const;

export const PRODUCT_TYPE_TO_DV_MAPPING = {
  CI: ContractTypes.CI,
  FPG: ContractTypes.FPG,
} as const;

export const GUARANTEE_TO_DV_MAPPING = {
  '75/100': Guarantees._75_100,
  '75/100 enrichie': Guarantees._75_100_enriched,
  'R12': Guarantees.Basic,
  'E12': Guarantees.Enhanced,
  'O12': Guarantees.Optimal,
  'N75': Guarantees.Standard,
  'N10': Guarantees.Premium,
  '6040': Guarantees.CIG_40,
  '4060': Guarantees.CIG_60,
} as const;

export const REDEEMABLE_FLAG_TO_DV_MAPPING = {
  R: Redeemability.REDEEMABLE,
  N: Redeemability.NON_REDEEMABLE,
} as const;

export const PERIODIC_DEPOSIT_FREQUENCY_TO_DV_MAPPING = {
  AN: UnitraxPeriodicDepositFrequency.Annual,
  BM: UnitraxPeriodicDepositFrequency.Bimonthly,
  BW: UnitraxPeriodicDepositFrequency.Biweekly,
  MO: UnitraxPeriodicDepositFrequency.Monthly,
  QT: UnitraxPeriodicDepositFrequency.Quarterly,
  SA: UnitraxPeriodicDepositFrequency.SemiAnnual,
  WK: UnitraxPeriodicDepositFrequency.Weekly,
} as const;

export const PERIODIC_DEPOSIT_STATUS_TO_DV_MAPPING = {
  AC: PeriodicDepositStatus.Active,
  HD: PeriodicDepositStatus.Held,
} as const;
